import React from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

export default function PopupMessage({ message, isOpen, onClose }) {
  return (
    <Popup open={isOpen} closeOnDocumentClick onClose={onClose} modal>
      <div className="modal">
        <div className="header">{message}</div>
        <div className="actions">
          <button className="close-button" onClick={onClose}>Close</button>
        </div>
      </div>
    </Popup>
  );
}
